module.exports = "/_next/static/images/64e19d31be3f726c607677523d6cd2f2-blog3-xs.png.webp";